"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Chip = _interopRequireDefault(require("../../Chip"));
var _utils = require("../utils");
var _utils2 = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FilterPanelSection = _ref => {
  let {
    data,
    searchData,
    searchTerm = "",
    sectionHidden,
    toggleSelected
  } = _ref;
  const {
    chips,
    heading
  } = data;
  const [overflowCounter, setOverflowCounter] = (0, _react.useState)(0);
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const chipWrapper = (0, _react.useRef)(null);
  const handleChipClick = chip => {
    toggleSelected(chip);
  };

  // If the offsetTop is more than double height of a single chip, consider it
  // overflowing
  const updateFlowCount = function () {
    var _chipWrapper$current;
    const chips = chipWrapper === null || chipWrapper === void 0 || (_chipWrapper$current = chipWrapper.current) === null || _chipWrapper$current === void 0 ? void 0 : _chipWrapper$current.querySelectorAll(".p-chip");
    const overflowCount = (0, _utils.overflowingChipsCount)(chips, 2);
    setOverflowCounter(overflowCount);
  };

  // Check if search term characters matches any characters in panel heading
  const searchTermInHeading = (0, _utils2.highlightSubString)(heading, searchTerm).match;

  // Serialise chip values into string so it can be interrogated with subString
  const chipValues = [];
  Object.entries(chips).forEach(chipValue => {
    chipValues.push(chipValue[1].value);
  });

  // Search chips for character match with search term
  const searchTermInChips = (0, _utils2.highlightSubString)(chipValues.toString(), searchTerm).match;
  const panelSectionVisible = searchTermInHeading || searchTermInChips || searchTerm === "";

  // Update overflow count when component is resized
  (0, _react.useEffect)(() => {
    const resizeObserverSupported = typeof ResizeObserver !== "undefined";
    const wrapper = chipWrapper === null || chipWrapper === void 0 ? void 0 : chipWrapper.current;
    let wrapperWidthObserver;
    if (resizeObserverSupported && panelSectionVisible) {
      wrapperWidthObserver = new ResizeObserver(() => {
        updateFlowCount();
      });
      wrapperWidthObserver.observe(wrapper);
    } else {
      updateFlowCount();
    }
    return () => {
      var _wrapperWidthObserver;
      resizeObserverSupported && ((_wrapperWidthObserver = wrapperWidthObserver) === null || _wrapperWidthObserver === void 0 ? void 0 : _wrapperWidthObserver.disconnect());
    };
  }, [panelSectionVisible]);

  // When overflow counter is clicked, all chips are shown
  const showAllChips = () => {
    setExpanded(true);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, panelSectionVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "p-filter-panel-section"
  }, heading && chips.length > 0 && /*#__PURE__*/_react.default.createElement("h3", {
    className: "p-filter-panel-section__heading",
    dangerouslySetInnerHTML: {
      __html: (0, _utils2.highlightSubString)(heading, searchTerm).text
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-filter-panel-section__chips",
    "aria-expanded": expanded,
    ref: chipWrapper
  }, chips === null || chips === void 0 ? void 0 : chips.map(chip => {
    // If search term has been added to input, only matching chips
    // should display
    const searchTermInChip = (0, _utils2.highlightSubString)(chip.value, searchTerm).match;
    const chipVisible = searchTermInChip || searchTerm === "" || (0, _utils2.highlightSubString)(heading, searchTerm).match;
    return chipVisible && !sectionHidden && /*#__PURE__*/_react.default.createElement(_Chip.default, {
      key: "".concat(chip.lead, "+").concat(chip.value),
      lead: chip.lead,
      value: chip.value,
      selected: (0, _utils.isChipInArray)(chip, searchData),
      subString: searchTerm,
      onClick: () => handleChipClick(chip)
    });
  }), overflowCounter > 0 && !expanded && /*#__PURE__*/_react.default.createElement("span", {
    className: "p-filter-panel-section__counter",
    onClick: showAllChips,
    onKeyPress: showAllChips,
    tabIndex: 0
  }, "+", overflowCounter))));
};
FilterPanelSection.propTypes = {
  searchData: _propTypes.default.array.isRequired,
  searchTerm: _propTypes.default.string.isRequired,
  sectionHidden: _propTypes.default.bool,
  toggleSelected: _propTypes.default.func.isRequired
};
var _default = exports.default = FilterPanelSection;